import makeStyles from "@mui/styles/makeStyles";
import { MobilePreviewProps } from "./MobilePreview.types";

export const useStyles = makeStyles((theme) => ({
  root: (props: MobilePreviewProps) => ({
    position: "relative",
    width: props.width,
    height: props.height,
    border: `8px solid ${theme.palette.grey[200]}`,
    borderRadius: 24,
    overflow: "hidden",
    padding: 2,
    "& > *": {
      borderRadius: 13,
    },
  }),
}));
